import { useEffect } from 'react';
import { Box, Button, makeStyles } from '@material-ui/core';
import { useSelector, useDispatch } from "react-redux";
import { initialUserMetrics } from '../../../../../store/reducers/creator/creatorExperienceBuilder';
import { updateUserAttributes, emptyUserMetrics, moveNextPage } from "../../../../../store/actions/creator/creatorExperienceBuilder";
import { getSessionParticipantsSuccess } from '../../../../../store/actions/creator/creatorExperienceManager';
import { emptyExperience } from '../../../../../store/actions/experience/experience';
import { useHistory } from "react-router";
import UtilService from "../../../../../helper/service";
import roles from "../../../../../helper/roles";

const useStyles = makeStyles((theme) => ({
  img: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    width: 480,
    height: 360,
    '@media (max-width: 1400px)': {
      width: 306,
      height: 300,
    },
  },
  btn: {
    width: 300,
    height: 54,
    borderRadius: 6,
    background: '#017AEF',
    color: '#fff',
    textTransform: 'none',
    fontSize: 19,
    '&:hover': {
      background: '#0f9fef',
      color: '#fff',
    },
  }
}));

function LiveExperienceFinish(Props:any) { 
  const classes = useStyles();
  const history = useHistory();
  const { userMetrics, page } = useSelector((state: any) => state.creatorExperienceBuilder);
  const { sessionCode, moderatedCompleted } = userMetrics;
  const apolloClient = useSelector((state: any) => state.apolloClient);
  const dispatch = useDispatch();

  const onReStart = () => {
    dispatch(getSessionParticipantsSuccess(null));
    const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : ""
    if (!!loginUserData) {
      const emptyRequest = {
        temporary_value: initialUserMetrics,
        user_id: loginUserData.user_id,
      };
      dispatch(updateUserAttributes(apolloClient.client, emptyRequest));
      dispatch(moveNextPage(0));
      dispatch(emptyUserMetrics());
      Props.setFieldChange(false)
      let url = `/creator/experience-manager/participants/${sessionCode}`;
      if (UtilService.checkTrialAccess(loginUserData, roles['trial']['experiences'])) {
        url = `/subscriber/creator/experience-manager/participants/${sessionCode}`;
      }
      Props.setConfirmationLeavePage(url);
      history.push(url);
    }
  };

  useEffect(() => {
    dispatch(emptyExperience());
  }, [dispatch]);

  useEffect(() => {
    !moderatedCompleted && dispatch(moveNextPage(page - 1));
    if (history.location.hash !== '#created') {
      UtilService.addHashTag(history, location.pathname, 'created');
    }
  }, []);

  return (
    <>
      <p className="creator-title mt-65">
        Congratulations. Your event is LIVE!
      </p>

      <p className='creator-main-title'>
        {userMetrics.moderatedName}
      </p>

      <Box justifyContent="center" display="flex">
        <img src="/assets/icons/experiencebuilder/live-final.svg" alt="avatar" className={classes.img} />
      </Box>

      <br />

      <Box mt={3} display='flex' flexDirection='row' alignItems='center' justifyContent='center'>
        <Button onClick={onReStart} color='primary' size='large' className={classes.btn}>
          Start Tracking Participants
        </Button>
      </Box>

    </>
  )
}

export default LiveExperienceFinish;